export default __webpack_public_path__ + "static/needlefilewithbluewax-e1479fde208c364313190848e8ecf3fb.png";